export const DownArrow = ({ className }: { className?: string }) => (
  <svg width="7" height="5" viewBox="0 0 7 5" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M3.09038 4.41483L0.550711 0.786732C0.318739 0.455343 0.555815 2.81684e-07 0.960327 2.64002e-07L6.03967 4.19773e-08C6.44418 2.42955e-08 6.68126 0.455343 6.44929 0.786732L3.90962 4.41483C3.71056 4.69919 3.28943 4.69919 3.09038 4.41483Z"
      fill="currentColor"
    />
  </svg>
);
